import React from "react";

const TagRules = ({ tag }) => {
	return (
		<div>
			{tag.OcrTag.name}

			{tag.OcrTag.configs.map((r) => (
				<div key={r.id}>
					<b>{r.type}</b> {r.fields} =&gt; {r.matches.join(', ')}
				</div>
			))}
		</div>
	)
};

export default TagRules;